import { SliceCaseReducers } from '@reduxjs/toolkit'
import CreateGenericSlice from '../GenericSlice'
import { ListAppointmentCardInterface } from '../../Interfaces/AppointmentCardInterface'
import { QueueStateEnum } from '../../enums/QueueStateEnum'

const store = CreateGenericSlice<
  ListAppointmentCardInterface,
  SliceCaseReducers<ListAppointmentCardInterface>
>({
  name: 'Appoinemnts',
  initialState: {
    appointments: [],
    appointmentCalled: [],
  },
  reducers: {
    insertPatient: (
      state,
      { payload }: { payload: ListAppointmentCardInterface }
    ) => {
      state.appointments = [...payload.appointments]
      state.dateMiladi = payload.dateMiladi
      state.dateShamsi = payload.dateShamsi
      state.doctorServeShift = payload.doctorServeShift
      state.showVisit = payload.showVisit
      state.showReception = payload.showReception
      state.showPayed = payload.showPayed
    },
    insertPatientCalled: (state, { payload }) => {
      state.appointmentCalled = payload.appointmentCalled
      state.dateMiladi = payload.dateMiladi
      state.dateShamsi = payload.dateShamsi
      state.doctorServeShift = payload.doctorServeShift
      state.showVisit = payload.showVisit
      state.showReception = payload.showReception
      state.showPayed = payload.showPayed
    },
    pushPatientCalled: (state, { payload }) => {
      const listCalled = [...state.appointmentCalled]
      const list = [...state.appointments].filter(
        (n) => n.ticketId !== payload.ticketId
      )

      payload.queueState = Object.entries(QueueStateEnum).find(x => x[1] === QueueStateEnum.DisplayedOnMonitor)?.[0]
      listCalled.push(payload)
      state.appointmentCalled = listCalled
      state.appointments = list
    },
    pushPatientAbsent: (state, { payload }) => {
      const listCalled = [...state.appointmentCalled]
      const index = listCalled.findIndex(x => x.ticketId === payload.ticketId)
      listCalled[index].queueState = Object.entries(QueueStateEnum).find(x => x[1] === QueueStateEnum.Absent)?.[0]
    },
  },
})

export const { insertPatient, insertPatientCalled, pushPatientCalled, pushPatientAbsent } =
  store.actions

export default store.reducer
